import PropTypes from 'prop-types';
import './MessageReactions.css';

const MessageReactions = ({ 
  reactions, 
  onToggleReaction: _onToggleReaction, 
  messageId,
  onHoverChange, 
  className = '',
  onReactionDetailsOpen = () => {},
}) => {
  if (!reactions || reactions.size === 0) {
    return null;
  }

  // Get the first 3 emoji reactions (sorted by most reactors)
  const reactionEntries = Array.from(reactions.entries())
    .sort((a, b) => b[1].length - a[1].length) // Sort by number of reactors
    .slice(0, 3);

  // Calculate total reactions count
  const totalReactionsCount = Array.from(reactions.values()).reduce(
    (total, reactors) => total + reactors.length,
    0,
  );

  const handleClick = () => {
    // Open reaction details sidebar when clicked
    if (onReactionDetailsOpen && reactions.size > 0) {
      const [firstEmoji, firstReactors] = Array.from(reactions.entries())[0];
      onReactionDetailsOpen(firstEmoji, firstReactors, messageId, reactions);
    }
  };

  const handleContainerMouseEnter = () => {
    if (onHoverChange) {
      onHoverChange(true);
    }
  };

  const handleContainerMouseLeave = () => {
    if (onHoverChange) {
      onHoverChange(false);
    }
  };

  return (
    <div 
      className={`message-reactions ${className}`}
      onClick={handleClick}
      onMouseEnter={handleContainerMouseEnter}
      onMouseLeave={handleContainerMouseLeave}
    >
      <div className="message-reactions-emojis">
        {reactionEntries.map(([emoji]) => (
          <span key={emoji} className="message-reaction-emoji">
            {emoji}
          </span>
        ))}
      </div>
      {totalReactionsCount > 1 && (
        <span className="message-reactions-count">{totalReactionsCount}</span>
      )}
    </div>
  );
};

MessageReactions.propTypes = {
  reactions: PropTypes.instanceOf(Map),
  onToggleReaction: PropTypes.func,
  messageId: PropTypes.string.isRequired,
  onHoverChange: PropTypes.func,
  className: PropTypes.string,
  onReactionDetailsOpen: PropTypes.func,
};

export default MessageReactions;